module.exports = __webpack_public_path__ + "static/media/upButton.ac908f7f.svg";